import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SectorsAirComponent } from './sectors-air.component';
import { SectorAirDetailsModule } from 'libraries/component/booking-information/components/sectors/components/sectors-air/sector-air-details/sector-air-details.module';
import { SectorAirSummaryModule } from './sector-air-summary/sector-air-summary.module';
import { SectorAirServicesModule } from './sector-air-services/sector-air-services.module';
import { SectorAirDeleteDialogModule } from './sector-air-delete-dialog/sector-air-delete-dialog.module';
import { SectorAirGroupModule } from './sector-air-group/sector-air-group.module';
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

@NgModule({
    imports: [
        CommonModule,
        SectorAirSummaryModule,
        SectorAirDetailsModule,
        SectorAirServicesModule,
        SectorAirDeleteDialogModule,
        SectorAirGroupModule,
        FontAwesomeModule,
    ],
    declarations: [
        SectorsAirComponent
    ],
    exports: [
        SectorsAirComponent,
    ]
})
export class SectorsAirModule { }